export default "__VITE_ASSET__20e57e17__"